import {percentChance} from '../../../helpers/numbers-helper.js'

export function getStatChanges(action, combatantMap, currentCombatantStateChanges, combatantModels) {

  //Copy the changes.
  let changes = {
    ...currentCombatantStateChanges
  };

  //Attack modifier up or down
  //TODO: no support for percentChance yet for attackModifier... but see Defense for reference.
  //It should work the exact same way.
  if (action.affectTargetAttackModifier !== 0) {
    combatantMap.targetIds.forEach(targetId => {
      const targetModel = combatantModels[targetId];
      changes.state[targetId].attackModifier = targetModel.attackModifier + action.affectTargetAttackModifier;

      //TODO: Perhaps might need valueCeiling to prevent player from boosting too high?
      //Alternatively, the action could fail if stat is already higher than a certain %.
      //For now, let's just let it fly...
    });
  }

  //Defense modifier up or down
  let affectTargetDefenseModifier = action.affectTargetDefenseModifier;
  affectTargetDefenseModifier = (typeof affectTargetDefenseModifier === "object") //percentChance object support
    ? extractValueFromChanceObject(affectTargetDefenseModifier)
    : affectTargetDefenseModifier;

  if (affectTargetDefenseModifier !== 0) {
    combatantMap.targetIds.forEach(targetId => {
      const targetModel = combatantModels[targetId];
      changes.state[targetId].defenseModifier = targetModel.defenseModifier + affectTargetDefenseModifier;

      //Document the diff
      changes.description.defenseChange = changes.description.defenseChange || {};
      changes.description.defenseChange[targetId] = affectTargetDefenseModifier; //Document this so we can message it to players
    });
  }


  //Speed modifier up or down
  if (action.affectTargetSpeedModifier !== 0) {
    combatantMap.targetIds.forEach(targetId => {
      const targetModel = combatantModels[targetId];
      changes.state[targetId].speedModifier = targetModel.speedModifier + action.affectTargetSpeedModifier;
    });
  }

  //Accuracy Modifier up or down
  if (action.affectTargetAccuracyModifier !== 0) {
    combatantMap.targetIds.forEach(targetId => {
      const targetModel = combatantModels[targetId];
      changes.state[targetId].accuracyModifier = targetModel.accuracyModifier + action.affectTargetAccuracyModifier;
    });
  }


  //Not capturing delta diffs at the moment for stats.. only the new values
  return changes;
}

/** Specific type of object that provides a value and a percentChance. Roll if the output should be the value or 0 */
function extractValueFromChanceObject(chanceObj, defaultValue = 0) {
  if (percentChance(chanceObj.percentChance)) {
    return chanceObj.value;
  }
  return defaultValue;
}


// WEBPACK FOOTER //
// ./src/battle/lifecycle/description/stats.js